/**
 * Format distance for display with Swedish locale (comma as decimal separator)
 * - < 1 km: show meters (e.g., "850 m")
 * - < 10 km: show 1 decimal (e.g., "3,2 km")
 * - >= 10 km: show no decimals (e.g., "15 km")
 */
export function formatDistanceKm(km: number): string {
  if (km < 1) {
    return `${Math.round(km * 1000)} m`;
  }
  if (km < 10) {
    return km.toLocaleString("sv-SE", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }) + " km";
  }
  return Math.round(km).toLocaleString("sv-SE") + " km";
}
